export enum EssayStatus {
    None = 0,
    New = 1,
    InProgress = 2,
    Done = 3,
    Accepted = 4,
    Rejected = 5,
}

export enum PaymentPurpose {
    SubscriptionEconomy = 1,
    SubscriptionStandard = 2,
    SubscriptionOptimal = 3,
    SubscriptionIntensive = 4,
}

export enum PromoStatus {
    None = 0,
    Valid = 1,
    NotValid = 2,
}